import React from "react";
import { cn } from "./cn";

/* The small uppercase label used across the claim intake steps. */
const LABEL_VARIANTS = {
  caption:
    "text-[11px] mb-2 font-semibold uppercase tracking-[0.06em] text-[var(--muted)]",
  field: "text-[13px] mb-1.5 font-bold text-[var(--ink)]",
};

export const FieldLabel = ({
  children,
  htmlFor,
  required = false,
  as,
  variant = "caption",
  className = "",
  ...rest
}) => {
  const Tag = as || (htmlFor ? "label" : "span");
  return (
    <Tag
      {...(Tag === "label" ? { htmlFor } : {})}
      className={cn(
        "block font-sans",
        LABEL_VARIANTS[variant] || LABEL_VARIANTS.caption,
        className
      )}
      {...rest}
    >
      {children}
      {required && (
        // Decorative: the control itself carries `required`, so announcing a
        // bare asterisk would only add noise.
        <span aria-hidden="true" className="ml-1 text-[var(--coral)]">
          *
        </span>
      )}
    </Tag>
  );
};

export default FieldLabel;
